import { render, staticRenderFns } from "./ModalAtualizarStatus.vue?vue&type=template&id=19b8fd12"
import script from "./ModalAtualizarStatus.vue?vue&type=script&lang=js"
export * from "./ModalAtualizarStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports